var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Table } from '@telia-front/table';
import { usePlaceholderArray, useSlidesToShowAmount } from './utils';
const ProductComparisonTable = (props) => {
    const { itemCount, isMobile, children } = props, rest = __rest(props, ["itemCount", "isMobile", "children"]);
    const visibleItemCount = useSlidesToShowAmount();
    const placeholders = usePlaceholderArray(itemCount);
    const totalItemCount = itemCount + placeholders.length;
    return (React.createElement(Table, Object.assign({ className: "product-comparison__table", minWidth: isMobile ? `${(totalItemCount / visibleItemCount) * 100}%` : undefined }, rest), children));
};
export default ProductComparisonTable;
